
import * as Yup from "yup";

export const validationSchema = Yup.object().shape({

  grade: Yup.number().test("grade", "Обязательно к заполнению", (value) => {
    return !!value
  }),
});